var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.posts.length > 0
    ? _c(
        "div",
        { staticClass: "card card-article" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("reviews", { attrs: { posts: _vm.posts } }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-light" }, [
      _c("div", { staticClass: "card-header-title" }, [
        _vm._v("\n            Review\n        "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }